import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadCoupon () {
    const api = getApiClient(this.$store)
    const couponId = this.$route.params.id

    api.get(`plan_coupons/${couponId}`)
      .then(result => {
        this.coupon = result.data

        const params = parseFilters({
            ...this.filters,
            ...{ 'coupon.code': this.coupon.code },
          },
        )

        api.get('plan_coupon_uses', { params })
          .then(result => {
            const data = result.data['hydra:member']
            const dates = data.map(item => {
              return item.date
            })

            const values = data.map(item => {
                return item.uses
            })

            this.chart.options = {
              ...this.chart.options,
              ...{
                xaxis: {
                  categories: dates,
                },
              },
            }

            this.chart.series[0].data = values
          })
      })
      .catch(error => {
        this.error = error.response
      })
  },
  clearFilters () {
    this.filters = {}
    this.loadCoupon()
  },
}
